<template>
  <div>
    <CRow>
      <CCol sm="12">
        <KamsTable
          :items="kams"
          hover
          striped
          border
          small
          fixed
          caption="Kams"
          @refresh="refreshItems"
          :permissions="permissions"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import KamsTable from '../../components/kams/KamsTable.vue'
import ws from '../../services/kams';
import account_ws from '../../services/account';
import store from '../../store'

export default {
  name: 'Kams',
  components: { KamsTable },
  data: function () {
		return {
            kams: [],
            permissions: null
        }
  },
  mounted: async function() {
    this.loading();
    let response = await ws.get();

    if(response.type == "success"){
      this.kams = response.data;
    }

    let response2 = await account_ws.getInfo(); 

    if(response2.type == "success"){
      this.permissions = response2.data.user.permissions;
    }

    this.loaded();
  },
  methods: {
    async refreshItems (items){
      this.loading();
      this.kams = await items;
      this.loaded();
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
